import { Mode } from '@arhs-fleetback/types/entities/common';
import type { ConfigAssignmentAssignmentTag } from '@arhs-fleetback/types/entities/tags';
import { TagColor } from '@arhs-fleetback/types/entities/tags';

import { FEATURES as FEATURES_ENUM } from 'constants/FeatureConstants';
import { ALL_MODES } from 'constants/ModeConstants';

export const DASHBOARD_DEALER_SOURCE = 'tags-dashboard-dealer';
export const DASHBOARD_GROUP_SOURCE = 'tags-dashboard-group';
export const DETAILS_SOURCE = 'tags-details';
export const MODAL_SOURCE = 'tags-modal';

export const DashboardTypeEnum = {
  DEALER: 'dealer',
  GROUP: 'group',
} as const;
export type DashboardTypeEnum = typeof DashboardTypeEnum[keyof typeof DashboardTypeEnum];

export const DEFAULT_TAG_COLOR = TagColor.BLUE;

/**
 * Where an assignment comes from. Distinct from `ENTITY_ORIGIN` (`modules/app/constants`), which
 * covers the `assignedBy` field and only ever holds DEALER or GROUP.
 *
 * TODO: drop the mirror once @arhs-fleetback/types re-exports AssignmentOriginEnum — it lives in
 * `entities/common/assigment` but neither the `common` barrel nor the `exports` map expose it.
 */
export type AssignmentOrigin = ConfigAssignmentAssignmentTag['origin'];
export const AssignmentOrigin: Record<AssignmentOrigin, AssignmentOrigin> = {
  DEALER: 'DEALER',
  DEFAULT: 'DEFAULT',
  GROUP: 'GROUP',
};

// Use for manage tags by features
export const TAG_FEATURES_BY_MODE = {
  [Mode.TECHNICIAN]: { FEATURES: [FEATURES_ENUM.TAGS_AFTERSALES] },
  [Mode.PARTS]: { FEATURES: [FEATURES_ENUM.TAGS_PARTS] },
  [Mode.SALES]: { FEATURES: [FEATURES_ENUM.TAGS_SALES] },
};

export const MODES_BY_TAG_FEATURE = {
  [FEATURES_ENUM.TAGS_AFTERSALES]: Mode.TECHNICIAN,
  [FEATURES_ENUM.TAGS_PARTS]: Mode.PARTS,
  [FEATURES_ENUM.TAGS_SALES]: Mode.SALES,
};

export const getModeByTagFeatures = (features: string[] = []) => {
  const modes = features.reduce<string[]>((acc, feature) => {
    const mode = MODES_BY_TAG_FEATURE[feature];
    if (mode) {
      acc.push(mode);
    }
    return acc;
  }, []);

  return ALL_MODES.filter(mode => modes.includes(mode));
};

export const TAG_NAME_MAX_LENGTH = 255;
